<p-dialog
  *transloco="let t"
  [header]="editMode() ? t('user.management.editUser') : t('user.management.addUser')"
  [(visible)]="visible"
  [style]="{width: '600px'}"
  [modal]="true"
  [closable]="false"
>
  <div class="flex flex-col gap-4 p-4">
    @if (scimManaged()) {
      <p-message severity="info" variant="simple" size="small" data-testid="scim-managed-hint">
        {{ t('user.scimManaged.hint') }}
      </p-message>
    }
    <form [formGroup]="theForm">
      <div class="grid grid-cols-2 gap-4 p-5">
        <app-form-field
          [id]="'firstName'"
          [fieldName]="'firstName'"
          [label]="t('common.firstName')"
          type="text"
          [step]="1"
          [disabledSignal]="scimManaged"
        ></app-form-field>

        <app-form-field
          [id]="'lastName'"
          [fieldName]="'lastName'"
          [label]="t('common.lastName')"
          type="text"
          [step]="1"
          [disabledSignal]="scimManaged"
        ></app-form-field>
      </div>
      <div class="grid grid-cols-1 gap-4 p-5">
        <app-form-field
          [id]="'email'"
          [fieldName]="'email'"
          [label]="t('common.email')"
          type="text"
          [step]="1"
          [disabledSignal]="emailFieldDisabled"
        ></app-form-field>
      </div>
      <div class="grid grid-cols-1 gap-4 p-5">
        <app-form-field
          [id]="'phoneNumber'"
          [fieldName]="'phoneNumber'"
          [label]="t('common.phoneNumber')"
          type="tel"
          [step]="1"
          [disabledSignal]="scimManaged"
        ></app-form-field>
      </div>
      <div class="grid grid-cols-1 gap-4 p-5">
        <app-form-field
          [id]="'role'"
          [fieldName]="'role'"
          [label]="t('common.role')"
          type="dropdownSelectV2"
          [dropDownOptionsV2]="roleOptions()"
          [selectedOptionId]="
            theForm.get('role')?.value?.role || theForm.get('role')?.value?.id || ''
          "
        ></app-form-field>
      </div>
    </form>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2 mt-4">
      <p-button
        [label]="'common.close' | transloco"
        (onClick)="close()"
        severity="secondary"
        data-testid="close-invoice-dialog-btn"
      />
      <p-button
        type="submit"
        [label]="'common.save' | transloco"
        [disabled]="theForm.invalid || isSaving()"
        (onClick)="onSubmit()"
        data-testid="submit-invoice-btn"
      />
    </div>
  </ng-template>
</p-dialog>
